import React, { useState } from 'react'
import { Helmet } from 'react-helmet'

// TODO: Bitte Pinterest Script-Lösung überprüfen.

const SocialShareBlock = ({ variant, pdfDownload = false }) => {
  const [socialShareState, setSocialShareState] = useState('close')

  const socialShareHandler = () => {
    if (socialShareState === 'open') {
      setSocialShareState('close')
    } else {
      setSocialShareState('open')
    }
  }

  let currentUrl = ''
  let encodedUrl = ''

  if (typeof window !== 'undefined') {
    currentUrl = window.location.href
  }
  if (currentUrl) {
    encodedUrl = encodeURIComponent(currentUrl)
  }

  return (
    <>
      <section className={`social-share-block ${variant}`}>
        <div className="social-share-block-wrapper">
          <div className="social-share-block-container">
            <div
              className={`dropdown social-share-block-dropdown ${
                socialShareState === 'open' ? 'show' : ''
              }`}
            >
              <button
                className="dropdown-toggle social-share-block-dropdown-btn"
                type="button"
                onClick={() => socialShareHandler('open')}
              >
                <i className="fas fa-share-alt"></i> Share
                {pdfDownload ? '/Download' : ''}
              </button>
              <div
                className={`dropdown social-share-block-dropdown ${
                  socialShareState === 'open' ? 'show' : ''
                }`}
              >
                <div
                  className={`dropdown-menu social-share-block-dropdown-menu dropdown-menu-right text-right ${
                    socialShareState === 'open' ? 'show' : ''
                  }`}
                >
                  <a
                    className="dropdown-item social-share-block-dropdown-item"
                    href={`https://www.facebook.com/sharer.php?u=${encodedUrl}`}
                    target="_blank"
                    title="Facebook"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    className="dropdown-item social-share-block-dropdown-item"
                    href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=&summary=&source=`}
                    target="_blank"
                    title="LinkedIn"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                  <a
                    className="dropdown-item social-share-block-dropdown-item"
                    href={`https://www.xing.com/spi/shares/new?url=${encodedUrl}`}
                    target="_blank"
                    title="Xing"
                  >
                    <i className="fab fa-xing"></i>
                  </a>
                  <a
                    className="dropdown-item social-share-block-dropdown-item"
                    href={`https://twitter.com/intent/tweet?url=${encodedUrl}`}
                    target="_blank"
                    title="Twitter"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>

                <a
                  className="dropdown-item social-share-block-dropdown-item"
                  data-pin-do="buttonBookmark"
                  data-pin-custom="true"
                  href="https://www.pinterest.com/pin/create/button/"
                  target="_blank"
                >
                  <i className="fab fa-pinterest"></i>
                </a>
                {pdfDownload && (
                  <a
                    className="dropdown-item social-share-block-dropdown-item"
                    rel="nofollow"
                    href={`https://partner.koenig-neurath.com/api/generate_pdf?url=${encodedUrl}`}
                    target="_blank"
                    title="Download PDF"
                  >
                    <i className="fas fa-file-pdf"></i>
                  </a>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Helmet>
        <script
          //type="opt-in"
          data-name="pinterest"
          async={true}
          defer={true}
          src="//assets.pinterest.com/js/pinit.js"
          type="application/javascript"
        ></script>
      </Helmet>
    </>
  )
}

export default SocialShareBlock
